// Copyright (c) Docugami, Inc. All rights reserved.

export enum ExtractionModel {
    MaverickAzure = "MaverickAzure",
    Gemini3Pro = "Gemini3Pro",
    Gemini2_5Pro = "Gemini2_5Pro",
    Gemini2_5Flash = "Gemini2_5Flash"
}

export interface ExtractionSettings {
    selectedModel: ExtractionModel;
}

export const DEFAULT_EXTRACTION_MODEL = ExtractionModel.MaverickAzure;
